import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath } from '../../config/Constant';
import { getServerDateTimeFailure, getServerDateTimeSuccess, initServerDateTimeRequest } from '../Reducers/serverDateTimeReducer';



export const getServerDateTime = () => {


  return async dispatch => {
    dispatch(initServerDateTimeRequest());

    try {
      const DeviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');

      let room = await AsyncStorage.getItem('room');
      let rn = room || 'notLogin';

      clientConfigPath.get(`/currentServerTimeDetails/fetch?dId=${DeviceIdentifier}&rn=${rn}`)
        .then(response => {
          console.log('serverDateTime-action------>', response.data);
          dispatch(getServerDateTimeSuccess(response.data?.payload));
        })
        .catch(error => {
          console.log('serverDateTime-action------>', error.message);
          dispatch(getServerDateTimeFailure(error.message));
        });
    } catch (error) {
      console.error('Error fetching data from AsyncStorage', error);
      dispatch(getServerDateTimeFailure(error.message));
    }
  };
};
